import { Injectable, inject } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { ServiceService } from '../../service/service.service';
import * as actions from './service.actions';
import { EffectFactory } from '../../../shared/store/common/effect.factory';

@Injectable()
export class ServiceEffects {
    private readonly actions$ = inject(Actions);
    private readonly api = inject(ServiceService);


    factory = new EffectFactory(this.actions$, actions, this.api).create();

}
